import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SurveyTagsApi } from '../../api/survey-tags/survey-tags.api';

@Injectable({ providedIn: 'root' })
export class SurveyTagsService {
  private readonly _api = inject(SurveyTagsApi);

  public getSurveyTags(surveyId: number): Observable<number[]> {
    return this._api.getSurveyTags(surveyId);
  }

  public linkSurveyTags(
    surveyId: number,
    tagIds: number[],
  ): Observable<number[]> {
    return this._api.linkSurveyTags(surveyId, tagIds);
  }
}
